function isIosWebKit() {
    if (void 0 === globalThis.window) return false;
    const ua = globalThis.navigator?.userAgent;
    return /iPhone/i.test(ua) && /WebKit/i.test(ua);
}
function createHiddenInput() {
    const el = document.createElement('input');
    el.setAttribute('type', 'text');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
    el.setAttribute('autocomplete', 'off');
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '-10000px';
    el.style.width = '1px';
    el.style.height = '1px';
    el.style.opacity = '0';
    el.style.caretColor = 'transparent';
    el.style.pointerEvents = 'none';
    el.style.fontSize = '16px';
    return el;
}
function focusInputWithoutScroll(input) {
    input?.focus({
        preventScroll: true
    });
}
function createNoopRelay() {
    const relay = (realInput)=>{
        focusInputWithoutScroll(realInput);
    };
    relay.cancel = ()=>{};
    return relay;
}
function beginIosKeyboardRelay(_anchor) {
    if (!isIosWebKit()) return createNoopRelay();
    const fakeInput = createHiddenInput();
    document.body.appendChild(fakeInput);
    fakeInput.focus({
        preventScroll: true
    });
    const cancel = ()=>{
        if (fakeInput.isConnected) fakeInput.remove();
    };
    const relay = (realInput)=>{
        focusInputWithoutScroll(realInput);
        cancel();
    };
    relay.cancel = cancel;
    return relay;
}
export { beginIosKeyboardRelay };
